var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { ApiService } from "../../../services/api-service/api-service";
import { postCommentError, postCommentStart, postCommentSuccess } from "./comments.action";
export const deleteComment = (id) => {
  return (dispatch) => {
    dispatch(postCommentStart());
    return ApiService.delete(`/replies/${id}`).then((res) => {
      dispatch(postCommentSuccess(res.data));
      return res.data;
    }).catch((err) => dispatch(postCommentError(err)));
  };
};
export const patchComment = (data, id) => {
  const body = {
    data: {
      type: "replay",
      attributes: __spreadValues({}, data)
    }
  };
  return (dispatch) => {
    dispatch(postCommentStart());
    return ApiService.patch(`/replies/${id}`, body).then((res) => {
      dispatch(postCommentSuccess(res.data));
      return res.data;
    }).catch((err) => dispatch(postCommentError(err)));
  };
};
export const postComment = ({ text, external_id, source, visibility }) => {
  const body = {
    data: {
      type: "replay",
      attributes: {
        visibility,
        text,
        external_id,
        source
      }
    }
  };
  return (dispatch) => {
    dispatch(postCommentStart());
    return ApiService.post("/replies", body).then((res) => {
      dispatch(postCommentSuccess(res.data));
      return res.data;
    }).catch((err) => dispatch(postCommentError(err)));
  };
};
